/**
 * Configuración central de la página.
 * Dejá un valor vacío ('' o null) para desactivar la función correspondiente.
 */

/** URL del checkout. Si queda vacía, todos los CTA llevan a la sección #oferta. */
export const CHECKOUT_URL = 'https://kit-halloween.impultienda.ar/checkout/disfraces';

/** Video del recorrido (YouTube, Vimeo o archivo .mp4). Vacío = portada "Próximamente". */
export const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/fcctFzTe7ccZBZEC4zEKpT/video-landing-liviano.mp4';

/** Contacto de soporte. Vacío = no se muestra. */
export const SUPPORT_EMAIL = 'visiondigitalsoporte@gmail.com';

/** Perfil de Instagram. Vacío = no se muestra. */
export const INSTAGRAM_URL = 'https://instagram.com/vision.digital02';

/**
 * Fecha fija de cierre de la oferta, con zona horaria (ej.: '2026-10-31T23:59:00-03:00').
 * null = no se muestra contador. Nunca se reinicia al recargar.
 */
export const PROMO_END_AT: string | null = '2026-10-25T23:59:00-03:00';

/** Cupos totales y vendidos. null = no se muestra el porcentaje. */
export const CUPOS_TOTAL: number | null = null;
export const CUPOS_VENDIDOS: number | null = null;

/** Aviso flotante de compras recientes (datos en data/recentPurchases.ts). false = oculto. */
export const SHOW_PURCHASE_NOTIFICATIONS = true;

/** Enlaces legales. Solo se muestran los que tengan una URL configurada. */
export const LEGAL_LINKS = {
  terminos: '',
  privacidad: '',
  condicionesDeCompra: '',
};

/** Imagen del mockup del kit. Reemplazala por la URL del mockup aprobado con fondo transparente. */
export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/bSkkeM7dWesCGVWqCUxNx3/mockup_1.1.png';

/* ── Producto y precios (todos los textos de precio salen de acá) ── */
export const PRODUCT_NAME = 'KIT DISFRACES DE HALLOWEEN';
export const COMPARE_PRICE = '$40.990';
/** Precio que regirá cuando termine el lanzamiento (PROMO_END_AT). */
export const NEXT_PRICE = '$24.990';

/**
 * true mientras dure el precio de lanzamiento. Al terminar PROMO_END_AT,
 * la página pasa sola a mostrar $24.990 (recordá actualizar también el checkout).
 */
export const LAUNCH_ACTIVE = PROMO_END_AT !== null && Date.now() < new Date(PROMO_END_AT).getTime();

export const PRICE_VALUE = LAUNCH_ACTIVE ? 19990 : 24990;
export const PRICE = LAUNCH_ACTIVE ? '$19.990' : '$24.990';
export const PRICE_ARS = `${PRICE} ARS`;
export const SAVINGS = LAUNCH_ACTIVE ? '$21.000' : '$16.000';
